var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15V12C5 11.4477 5.44772 11 6 11H10C10.5523 11 11 11.4477 11 12V15M14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H10.5858C10.851 1 11.1054 1.10536 11.2929 1.29289L14.7071 4.70711C14.8946 4.89464 15 5.149 15 5.41421V14C15 14.5523 14.5523 15 14 15Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2b03ee197a1795d9d70a56cace8ef913.svg";
export { ForwardRef as ReactComponent };